/**
 * src/components/directory/CategoryCard.js
 *
 * Tarjeta de una categoría del directorio.
 * Props: { icon, name, count, slug }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('CategoryCard', ({ icon, name, count, slug }) => {
    const card = h('a', {
        className: 'cat-card',
        href:      `/directorio/${slug}`
    },
        h('span', { className: 'cat-card__icon' }, icon),
        h('span', { className: 'cat-card__name'  }, name),
        h('span', { className: 'cat-card__count' }, `${count} negocio${count !== 1 ? 's' : ''}`)
    )

    return card
})
